import gql from 'graphql-tag';

export const GET_DASHBOARD_BILLING_SUMMARY = gql`
  query GetGuarantorSummary {
    guarantor {
      amountDue
      dueStatus
      totalEncounters
    }
  }
`;
